interface EmptyStateProps {
  title: string;
  description: string;
}

/** Placeholder empty state for routes that have no data wiring yet. */
export function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">{title}</h1>
      <div className="mt-8 rounded-lg border border-dashed border-gray-300 bg-white px-6 py-16 text-center dark:border-gray-700 dark:bg-gray-800">
        <p className="text-sm text-gray-500 dark:text-gray-400">{description}</p>
      </div>
    </div>
  );
}
